import React from 'react'

import { Body1, Box, Color, Heading4, Image, TextAlign } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { DeviceType, useDeviceType } from '@library/dom'

import { menuPreferencesVisibilityChange } from 'actions/menu'
import { incrementTutorialViewed, tutorialTracking } from 'actions/tutorial'
import { Portal } from 'routes/Menu/components/Portal'
import { Step, Tutorial } from 'routes/Menu/components/Tutorial'

import menuPreferencesSpotlightImage from 'media/photos/menu-preferences-spotlight.jpg'

import { MENU_PREFERENCES_TUTORIAL_NAME } from './useShouldShowMenuPreferencesTutorial'

export const MenuPreferencesTutorial = () => {
  const dispatch = useDispatch()
  const deviceType = useDeviceType()

  const openSidebar = () => {
    dispatch(menuPreferencesVisibilityChange(true))
  }

  const onCloseTutorial = (step: number) => {
    dispatch(incrementTutorialViewed(MENU_PREFERENCES_TUTORIAL_NAME))
    dispatch(tutorialTracking(MENU_PREFERENCES_TUTORIAL_NAME, step, true))
  }

  const trackStepViewed = (step: number) => {
    dispatch(tutorialTracking(MENU_PREFERENCES_TUTORIAL_NAME, step, false))
  }

  return (
    <Portal>
      <Tutorial onClose={onCloseTutorial} trackStepViewed={trackStepViewed}>
        <Step
          buttonText="Set preferences"
          next={openSidebar}
          selector={`[data-testid="menu-preferences-button-${
            deviceType === DeviceType.DESKTOP ? 'desktop' : 'mobile'
          }"]`}
        >
          <Box paddingH={3}>
            <Box maxWidth="380px" paddingBottom={4}>
              <Image alt="Recipe information preferences" src={menuPreferencesSpotlightImage} />
            </Box>
            <Heading4 color={Color.Primary_600} textAlign={TextAlign.Center}>
              Edit the information you see
            </Heading4>
            <Body1 textAlign={TextAlign.Center}>See what matters most at a glance</Body1>
          </Box>
        </Step>
      </Tutorial>
    </Portal>
  )
}
